import { apiRequest } from '@/services/api'
import { customLogger } from "@/utils";

const state = {
  token: window.localStorage.getItem('cleed_JWT') || undefined,
  subscribed: false,
}

const actions = {
  CREATE_NEW_USER_ANONYMOUS: ({state, commit}, params) => {
    return new Promise((resolve, reject) => {
      apiRequest().post('users/create', params).then(res=>{
        // customLogger(res);
        commit("SET_TOKEN", res.data.token)
        resolve(res)
      }).catch(err=>{
        // customLogger(err.response);
        reject(err.response)
      })
    })
  },
  CREATE_NEW_USER_BY_EMAIL: ({state, commit, rootState}, params) => {
    return new Promise((resolve, reject) => {
      apiRequest().post('auth/signup_email', {...params, store_id: rootState.config.storeId, lang: rootState.user.lang}).then(res=>{
        resolve(res)
      }).catch(err=>{
        reject(err.response)
      })
    })
  },
  SIGNIN_USER_BY_EMAIL: ({state, commit, rootState}, params) => {
    return new Promise((resolve, reject) => {
      apiRequest().post('auth/signin_email', {...params, store_id: rootState.config.storeId}).then(res=>{
        commit("SET_TOKEN", res.data.token)
        commit("SET_DATA_SUBSCRIPTION", res.data.user.subscription)
        customLogger("PROFILE STATE ==== ", res.data.user.profileState)
        commit("SET_PROFILE_STATE", res.data.user.profileState)
        resolve(res)
      }).catch(err=>{
        reject(err.response)
      })
    })
  },
  LOGOUT: ({state, commit}) => {
    window.localStorage.removeItem('cleed_JWT')
    state.token = undefined
    state.subscribed = false
    commit("SHOW_AUTH_FLOW", true)
  },

  SEND_OTP_FORGOT_PASSWORD: async ({ commit, rootState }, email) => {
    try {
      const response = await apiRequest().post('auth/forgot_password', { email, lang: rootState.user.lang });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  VERIFY_OTP_EMAIL: async ({ commit }, data) => {
    try {
      const response = await apiRequest().post('auth/verify_otp_email', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  UPDATE_PASSWORD: async ({ commit }, { email, newPassword, otp }) => {
    try {
      const response = await apiRequest().post('auth/update_password', { email, newPassword });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

}

const mutations = {
  SET_TOKEN: (state, token) => {
    window.localStorage.setItem('cleed_JWT', token)
    state.token = token
  },
}

export default {
  state,
  actions,
  mutations
}
